<template>
  <div class="chart-menu-component pt-2">
    <div class="submenu_tags">
      <div class="underline"></div>
      <v-icon size="20" class="mr-1">info</v-icon>
      <div class="menuitem" @click="ul(0)">
        <span class="menutext">Information</span>
      </div>
      <v-icon size="20" class="mr-1">list</v-icon>
      <div class="menuitem" @click="ul(1)">
        <span class="menutext">Trade List</span>
      </div>

      <!--
       <v-icon size="20" class="mr-1">insert_chart</v-icon>
      <div class="menuitem" @click="ul(2)">
        <span class="menutext">Statistics</span>
      </div>
      <v-icon size="20" class="mr-1">find_in_page</v-icon>
      <div class="menuitem" @click="ul(3)">
        <span class="menutext">Analysis & Simulation</span>
      </div>
      -->

      <div class="menuitem mar-0">
        <!-- <modalsSettings :type="this.parentData" /> -->
      </div>
    </div>
  </div>
</template>

<script>
//import modalsSettings from "./settings";

export default {
  props: ["parentData"],

  components: {
    //modalsSettings
  },

  data() {
    return {
      name: "Submenu",
      dialog: false
      //selected: this.$store.getters.userSubmenus[this.parentData].selected
    };
  },
  computed: {},
  methods: {
    // submenu click

    ul(newSelection) {
      //if (this.parentData == 0) this.$store.dispatch("CHANGE_DATA", index);
      this.$emit("view", newSelection)
      var selectedIndex = newSelection;
      //var itemsArray = this.$store.getters.userSubmenus[this.parentData].items;
      //var selectedIndex = itemsArray.indexOf(selectedItem);

      var menuitem = document.querySelectorAll(".submenu_tags .menuitem");
      var menutext = document.querySelectorAll(
        ".submenu_tags .menuitem .menutext"
      );

      for (var i = 0; i < menutext.length; i++) {
        menutext[i].style.color = null;
      }
      menutext[selectedIndex].style.color = "#FFFFFF";
      var width = menutext[selectedIndex].offsetWidth;
      var x = menuitem[selectedIndex].offsetLeft;
      var underlines = document.querySelectorAll(".submenu_tags .underline");
      underlines[0].style.width = width + "px";
      underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
    }
  },
  mounted() {
    //var itemsArray = this.$store.getters.userSubmenus[this.parentData].items;
    //var selectedIndex = itemsArray.indexOf(selectedItem);

    setTimeout(() => {
      var selectedIndex = 0;

      // initial submenut underline (after short timeout)
      var menuitem = document.querySelectorAll(".submenu_tags .menuitem");
      var menutext = document.querySelectorAll(
        ".submenu_tags .menuitem .menutext"
      );
      menutext[selectedIndex].style.color = "#FFFFFF";
      var width = menutext[selectedIndex].offsetWidth;
      var x = menuitem[selectedIndex].offsetLeft;
      var underlines = document.querySelectorAll(".submenu_tags .underline");
      underlines[0].style.width = width + "px";
      underlines[0].style.transform = "translate3d(" + x + "px,0,0)";
    }, 200);
  }
};
</script>

<style scoped>
.underline {
  background: #4dbac0;
  display: block;
  position: absolute;
  z-index: 5;
  height: 10px;
  bottom: 0;
  left: 0;
  height: 0.25em;
  background: #4dbac0;
  pointer-events: none;
  transition: -webkit-transform 0.3s ease-in-out, -webkit-width 0.3s ease-in-out;
  transition: 0.3s ease-in-out, width 0.3s ease-in-out;
  transition: 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out,
    width 0.3s ease-in-out, -webkit-width 0.3s ease-in-out;
}
.chart-menu-component {
  position: relative;
  float: right;
  white-space: nowrap;
  box-shadow: 0 1em 2em rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(128, 143, 156, 0.2);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
  z-index: 3;
}
.sajz {
  transform: scale(0.7, 0.7);
  position: relative;
  top: 3px;
}
.menuitem {
  font-weight: bold;
  font-size: 12px;
  color: #808f9c;
  display: inline-block;
  z-index: 10;
  text-align: left;
  cursor: pointer;
  margin-right: 28px;
}

.menuitem:hover {
  color: #ffffff;
}
.my-vbadge {
  font-size: 10px !important;
}

.menutext {
  margin-right: 3px;
}
</style>
